import { render, staticRenderFns } from "./address-modal.vue?vue&type=template&id=86854bc8&scoped=true"
import script from "./address-modal.vue?vue&type=script&lang=js"
export * from "./address-modal.vue?vue&type=script&lang=js"
import style0 from "./address-modal.vue?vue&type=style&index=0&id=86854bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86854bc8",
  null
  
)

export default component.exports